import { writable } from 'svelte/store';

export const answers = writable({
  'a': {},
  'extra': {}
});